import * as i0 from '@angular/core';
import { InjectionToken, Injectable, inject, Inject, NgModule } from '@angular/core';
import { HttpClient, HttpParams, HttpClientModule } from '@angular/common/http';
import { map } from 'rxjs';
import { CommonModule } from '@angular/common';

const RENTALS_API_CLIENT_CONFIG = new InjectionToken('RentalsApiClientConfig');
class RentalsApiClientConfigService {
    constructor() {
        this.config = {
            apiUrl: ""
        };
    }
    setConfig(config) {
        this.config = config;
    }
    getConfigItem(key) {
        return this.config[key];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientConfigService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

Injectable({ providedIn: 'root' });
class CompanyFeaturesBaseService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getCompanyFeatures() {
        const url = `${this.configService.getConfigItem('apiUrl')}/base/company-features`;
        return this.http.get(url);
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getIncidentReportById(id) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/${id}`;
        return this.http.get(url);
    }
    getIncidentReportsByReservationId(reservationId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report`;
        const params = { reservationId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    updateIncidentReportById(id, data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/${id}`;
        const body = data;
        return this.http.put(url, body);
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportCompositeService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getIncidentReportById(id) {
        const url = `${this.configService.getConfigItem('apiUrl')}/composite/incident-report/${id}`;
        return this.http.get(url);
    }
    getIncidentReports() {
        const url = `${this.configService.getConfigItem('apiUrl')}/composite/incident-report`;
        return this.http.get(url).pipe(map(response => response.items));
    }
    getIncidentReportsByReservationId(reservationId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/composite/incident-report`;
        const params = { reservationId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    createIncidentReport(data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/composite/incident-report`;
        const body = data;
        return this.http.post(url, body).pipe(map(response => response.item));
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportReporterApprovalCompositeService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    createReporterApproval(incidentReportId, data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/composite/incident-report/${incidentReportId}/reporter/approval`;
        const body = data;
        return this.http.post(url, body);
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportReporterApprovalStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getSignedApprovalSignatureUrl(incidentReportId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/${incidentReportId}/reporter/approval`;
        return this.http.get(url);
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportDamageStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getDamageOptions() {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/damage`;
        return this.http.get(url).pipe(map(response => response.items));
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportInjuryStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getInjuryOptions() {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/injury`;
        return this.http.get(url).pipe(map(response => response.items));
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportNoteStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getNotebyId(incidentReportNoteId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/${incidentReportNoteId}`;
        return this.http.get(url);
    }
    getNotesbyIncidentReportId(incidentReportId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note`;
        const params = { incidentReportId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    createNote(noteCreate) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note`;
        const body = noteCreate;
        return this.http.post(url, body);
    }
    updateNote(incidentReportNoteId, noteUpdate) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/${incidentReportNoteId}`;
        const body = noteUpdate;
        return this.http.put(url, body);
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportNoteMediaFileStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getUploadDetails(incidentReportNoteId, filename, contentType) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file/upload-details`;
        const params = { incidentReportNoteId, filename, contentType };
        const options = { params };
        return this.http.get(url, options);
    }
    createMediaFile(incidentReportNoteMediaFileCreate) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file`;
        const body = incidentReportNoteMediaFileCreate;
        return this.http.post(url, body);
    }
    getMediaFilesByIncidentReportNoteId(incidentReportNoteId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file`;
        const params = { incidentReportNoteId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    getMediaFileById(mediaFileId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file/${mediaFileId}`;
        return this.http.get(url);
    }
    downloadMediaFileById(mediaFileId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file/${mediaFileId}/file`;
        return this.http.get(url);
    }
    downloadMediaFileThumbnailById(mediaFileId, size, contentDispositionType) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file/${mediaFileId}/thumbnail`;
        const params = { size, contentDispositionType };
        const responseType = 'blob';
        const options = { params, responseType };
        return this.http.get(url, options);
    }
    getMediaFileLinkById(mediaFileId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file/${mediaFileId}/link`;
        return this.http.get(url);
    }
    updateMediaFile(mediaFileId, mediaFileUpdate) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file/${mediaFileId}`;
        const body = mediaFileUpdate;
        return this.http.put(url, body);
    }
    deleteMediaFile(mediaFileId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/note/media-file/${mediaFileId}`;
        return this.http.delete(url);
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportMediaFileStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getUploadDetails(incidentReportId, filename, contentType) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file/upload-details`;
        const params = { incidentReportId, filename, contentType };
        const options = { params };
        return this.http.get(url, options);
    }
    createMediaFile(incidentReportMediaFileCreate) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file`;
        const body = incidentReportMediaFileCreate;
        return this.http.post(url, body);
    }
    getMediaFilesByIncidentReportId(incidentReportId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file`;
        const params = { incidentReportId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    getMediaFileById(mediaFileId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file/${mediaFileId}`;
        return this.http.get(url);
    }
    downloadMediaFileById(mediaFileId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file/${mediaFileId}/file`;
        return this.http.get(url);
    }
    downloadMediaFileThumbnailById(mediaFileId, size, contentDispositionType) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file/${mediaFileId}/thumbnail`;
        const params = { size, contentDispositionType };
        const responseType = 'blob';
        const options = { params, responseType };
        return this.http.get(url, options);
    }
    getMediaFileLinkById(mediaFileId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file/${mediaFileId}/link`;
        return this.http.get(url);
    }
    updateMediaFile(mediaFileId, mediaFileUpdate) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file/${mediaFileId}`;
        const body = mediaFileUpdate;
        return this.http.put(url, body);
    }
    deleteMediaFile(mediaFileId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/media-file/${mediaFileId}`;
        return this.http.delete(url);
    }
}

Injectable({ providedIn: 'root' });
class IncidentReportSummaryDocumentStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    downloadSummaryById(incidentReportId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/incident-report/${incidentReportId}/summary-document/file`;
        return this.http.get(url, { responseType: 'blob' });
    }
}

Injectable({ providedIn: 'root' });
class ProductBaseService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getProductbyId(productId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/base/product/${productId}`;
        return this.http.get(url);
    }
}

Injectable({ providedIn: 'root' });
class ProductTypeStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getProductTypeByProductTypeId(productTypeId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type/${productTypeId}`;
        return this.http.get(url);
    }
}

Injectable({ providedIn: 'root' });
class ReservationSignedDocumentStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    createCancellationPolicySignedDocument(reservationId, signedDocument) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/reservation/${reservationId}/signed-document/cancellation-policy`;
        const body = signedDocument;
        return this.http.post(url, body);
    }
}

Injectable({ providedIn: 'root' });
class ReservationCompositeService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getResservationById(reservationId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/composite/reservation/${reservationId}`;
        return this.http.get(url);
    }
    getDashboardReservations(startDate, endDate, pageNumber, pageSize, sortBy = 'startDate', sortDirection = 'ASC', searchText = '', inventoryTypeId = [], reservationStatusId = []) {
        const url = `${this.configService.getConfigItem('apiUrl')}/composite/reservation/dashboard`;
        const params = new HttpParams({ fromObject: { startDate, endDate, pageNumber, pageSize, sortBy, sortDirection, searchText, inventoryTypeId, reservationStatusId } });
        return this.http.get(url, { params });
    }
    launchReservation(reservationId, data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/composite/reservation/${reservationId}`;
        const body = data;
        return this.http.put(url, body);
    }
}

Injectable({ providedIn: 'root' });
class ReservationStatusStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getReservationStatuses() {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/reservation-status`;
        return this.http.get(url).pipe(map(response => response.items));
    }
}

Injectable({ providedIn: 'root' });
class InventoryTypeBaseService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getInventoryTypes(inventoryTypeName) {
        const url = `${this.configService.getConfigItem('apiUrl')}/base/pricing/inventory-type`;
        const params = new HttpParams();
        if (inventoryTypeName) {
            params.set('inventoryTypeName', inventoryTypeName);
        }
        return this.http.get(url).pipe(map(response => response.items));
    }
}

Injectable({ providedIn: 'root' });
class ManifestAttestationStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getManifestGuestAttestationSettingsByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/attestation`;
        const params = { manifestId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    getManifestEmployeeAttestationSignature(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/employee/attestation/signature`;
        return this.http.get(url);
    }
    createManifestAttestationSignature(data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/attestation`;
        const body = data;
        return this.http.post(url, body);
    }
}

Injectable({ providedIn: 'root' });
class ManifestEmployeeApprovalStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getSignedManifestEmployeeApprovalSignatureURL(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/employee/approval`;
        return this.http.get(url).pipe(map(response => response.items));
    }
    createManifestEmployeeApprovalSignature(manifestId, data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/employee/approval`;
        const body = data;
        return this.http.post(url, body);
    }
}

Injectable({ providedIn: 'root' });
class ManifestProductEquipmentCheckStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getEquipmentCheckByManifestProductIDandManifestID(manifestProductId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/equipment-check`;
        const params = { manifestProductId, manifestId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    createEquipmentCheck(data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/equipment-check`;
        const body = data;
        return this.http.post(url, body);
    }
}

Injectable({ providedIn: 'root' });
class ManifestProductEquipmentItemStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getEquipmentItemByManifestProductIDandManifestID(manifestProductId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/equipment-item`;
        const params = { manifestProductId, manifestId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    createEquipmentItem(data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/equipment-item`;
        const body = data;
        return this.http.post(url, body);
    }
    createMultipleEquipmentItem(data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/equipment-item`;
        const body = data;
        return this.http.post(url, body);
    }
    updateEquipmentItemByManifestProductEquipmentItemID(manifestProductEquipmentItemID, data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/equipment-item/${manifestProductEquipmentItemID}`;
        const body = data;
        return this.http.put(url, body);
    }
}

Injectable({ providedIn: 'root' });
class ManifestProductSafetyBriefingStepStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getSafetyBriefingStepsByManifestProductIDandManifestID(manifestProductId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/safety-briefing-step`;
        const params = { manifestProductId, manifestId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    createSafetyBriefingStep(data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/safety-briefing-step`;
        const body = data;
        return this.http.post(url, body);
    }
}

Injectable({ providedIn: 'root' });
class ManifestProductStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getManifestProductsByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product`;
        const params = { manifestId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
    getRenterPolicyQuoteById(quoteId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/insurance-episode/renter-quote/${quoteId}`;
        return this.http.get(url);
    }
    updateManifestProductsById(manifestProductId, data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/${manifestProductId}`;
        const body = data;
        return this.http.put(url, body);
    }
}

Injectable({ providedIn: 'root' });
class ManifestProductTypeEquipmentCheckStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getEquipmentCheckByProductTypeIDandManifestID(productTypeId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/product-type/${productTypeId}/equipment-check`;
        const params = { productTypeId, manifestId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
}

Injectable({ providedIn: 'root' });
class ManifestProductTypeEquipmentItemStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getEquipmentItemByProductTypeIDandManifestID(productTypeId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/product-type/${productTypeId}/equipment-item`;
        const params = { productTypeId, manifestId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
}

Injectable({ providedIn: 'root' });
class ManifestProductTypeSafetyBriefingStepStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getSafetyBriefingStepsByManifestProductIDandManifestID(productTypeId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/product-type/${productTypeId}/safety-briefing-step`;
        const params = { productTypeId, manifestId };
        const options = { params };
        return this.http.get(url, options).pipe(map(response => response.items));
    }
}

Injectable({ providedIn: 'root' });
class ManifestReadyToLaunchStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getAttestationCompletionByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/attestation/ready-to-launch`;
        return this.http.get(url);
    }
    getSafetyBriefingCompletionByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/product/safety-briefing-step/ready-to-launch`;
        return this.http.get(url);
    }
    getEquipmentCheckCompletionByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/product/equipment-check/ready-to-launch`;
        return this.http.get(url);
    }
    getEquipmentItemsCompletionByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/product/equipment-item/ready-to-launch`;
        return this.http.get(url);
    }
    getPreRentalPhotosCompletionByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/product/pre-rental-photo/ready-to-launch`;
        return this.http.get(url);
    }
}

class ManifestProductPreRentalPhotoStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getPreRentalPhotosByManifestProductIdAndManifestId(manifestProductId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/pre-rental-photo`;
        const params = { manifestProductId, manifestId };
        const options = { params };
        return this.http.get(url, options);
    }
    getPreRentalPhotosByProductTypeIdAndManifestId(productTypeId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/pre-rental-photo`;
        const params = { productTypeId, manifestId };
        const options = { params };
        return this.http.get(url, options);
    }
    getUploadDetailsByManifestProductIdAndManifestId(manifestProductId, manifestId, productTypePreRentalPhotoVersionId, filename, contentType = 'image/jpeg') {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/pre-rental-photo/upload-details`;
        const params = { manifestProductId, manifestId, productTypePreRentalPhotoVersionId, filename, contentType };
        const options = { params };
        return this.http.get(url, options);
    }
    getUploadDetailsByProductTypeIdAndManifestId(productTypeId, manifestId, productTypePreRentalPhotoVersionId, filename, contentType = 'image/jpeg') {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/pre-rental-photo/upload-details`;
        const params = { productTypeId, manifestId, productTypePreRentalPhotoVersionId, filename, contentType };
        const options = { params };
        return this.http.get(url, options);
    }
    checkFileUploadedByManifestProductIdAndManifestId(manifestProductId, manifestId, productTypePreRentalPhotoVersionId, uuid, filename) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/pre-rental-photo/manifest/${manifestId}/manifest-product/${manifestProductId}/product-type-pre-rental-photo-version/${productTypePreRentalPhotoVersionId}/${uuid}/${filename}`;
        return this.http.get(url);
    }
    checkFileUploadedByProductTypeIdAndManifestId(productTypeId, manifestId, productTypePreRentalPhotoVersionId, uuid, filename) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/pre-rental-photo/manifest/${manifestId}/product-type/${productTypeId}/product-type-pre-rental-photo-version/${productTypePreRentalPhotoVersionId}/${uuid}/${filename}`;
        return this.http.get(url);
    }
    createPreRentalPhotoWithManifestProductId(manifestId, manifestProductId, productTypePreRentalPhotoVersionId, filename, uuid) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/pre-rental-photo`;
        const body = {
            manifestId,
            manifestProductId,
            productTypePreRentalPhotoVersionId,
            filename,
            uuid
        };
        return this.http.post(url, body);
    }
    createPreRentalPhotoWithProductTypeId(manifestId, productTypeId, productTypePreRentalPhotoVersionId, filename, uuid) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/product/pre-rental-photo`;
        const body = {
            manifestId,
            productTypeId,
            productTypePreRentalPhotoVersionId,
            filename,
            uuid
        };
        return this.http.post(url, body);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ManifestProductPreRentalPhotoStandardService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ManifestProductPreRentalPhotoStandardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ManifestProductPreRentalPhotoStandardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ManifestProductTypePreRentalPhotoStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getPreRentalPhotosByManifestIdAndProductTypeId(manifestId, productTypeId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}/product-type/${productTypeId}/pre-rental-photo`;
        return this.http.get(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ManifestProductTypePreRentalPhotoStandardService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ManifestProductTypePreRentalPhotoStandardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ManifestProductTypePreRentalPhotoStandardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

Injectable({ providedIn: 'root' });
class ManifestStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getManifestByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}`;
        return this.http.get(url).pipe(map(response => response.items));
    }
    updateManifestByManifestId(manifestId, data) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/manifest/${manifestId}`;
        const body = data;
        return this.http.put(url, body);
    }
}

class ProductTypePreRentalPhotoStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getPreRentalPhotos(productTypeId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-pre-rental-photo`;
        const params = { productTypeId };
        const options = { params };
        return this.http.get(url, options);
    }
    createPreRentalPhoto(payload) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-pre-rental-photo`;
        return this.http.post(url, payload);
    }
    updatePreRentalPhoto(productTypePreRentalPhotoId, payload) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-pre-rental-photo/${productTypePreRentalPhotoId}`;
        return this.http.put(url, payload);
    }
    deletePreRentalPhotoById(productTypePreRentalPhotoId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-pre-rental-photo/${productTypePreRentalPhotoId}`;
        return this.http.delete(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypePreRentalPhotoStandardService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypePreRentalPhotoStandardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypePreRentalPhotoStandardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ProductTypePreRentalPhotoConfigurationStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getPreRentalPhotoConfigurationById(productTypePreRentalPhotoConfigurationId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-pre-rental-photo-configuration/${productTypePreRentalPhotoConfigurationId}`;
        return this.http.get(url);
    }
    getPreRentalPhotoConfigurationByProductTypeId(productTypeId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-pre-rental-photo-configuration/product-type/${productTypeId}`;
        return this.http.get(url);
    }
    getPreRentalPhotoConfigurationByProductTypeIdAndManifestId(productTypeId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-pre-rental-photo-configuration/product-type/${productTypeId}/manifest/${manifestId}`;
        return this.http.get(url);
    }
    getPreRentalPhotoConfigurationsByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-pre-rental-photo-configuration/manifest/${manifestId}`;
        return this.http.get(url);
    }
    createPreRentalPhotoConfiguration(payload, productTypeId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/pre-rental-photo-configuration/${productTypeId}`;
        return this.http.post(url, payload);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypePreRentalPhotoConfigurationStandardService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypePreRentalPhotoConfigurationStandardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypePreRentalPhotoConfigurationStandardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

Injectable({ providedIn: 'root' });
class ProductTypeEquipmentCheckConfigurationStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getEquipmentCheckConfiguration(productTypeId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-equipment-check-configuration/product-type/${productTypeId}/manifest/${manifestId}`;
        return this.http.get(url);
    }
    getEquipmentCheckConfigurationsByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-equipment-check-configuration/manifest/${manifestId}`;
        return this.http.get(url);
    }
}

Injectable({ providedIn: 'root' });
class ProductTypeEquipmentItemConfigurationStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getEquipmentItemConfiguration(productTypeId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-equipment-item-configuration/product-type/${productTypeId}/manifest/${manifestId}`;
        return this.http.get(url);
    }
    getEquipmentItemConfigurationsByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-equipment-item-configuration/manifest/${manifestId}`;
        return this.http.get(url);
    }
}

Injectable({ providedIn: 'root' });
class ProductTypeSafetyBriefingStepConfigurationStandardService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
    }
    getSafetyBriefingStepConfiguration(productTypeId, manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-safety-briefing-step-configuration/product-type/${productTypeId}/manifest/${manifestId}`;
        return this.http.get(url);
    }
    getSafetyBriefingStepConfigurationsByManifestId(manifestId) {
        const url = `${this.configService.getConfigItem('apiUrl')}/standard/product-type-safety-briefing-step-configuration/manifest/${manifestId}`;
        return this.http.get(url);
    }
}

class RentalsApiClientService {
    constructor(config) {
        this.config = config;
        this.company = {
            base: {},
            standard: {},
            features: {
                base: inject(CompanyFeaturesBaseService),
            }
        };
        this.incidentReport = {
            standard: inject(IncidentReportStandardService),
            composite: inject(IncidentReportCompositeService),
            damage: {
                standard: inject(IncidentReportDamageStandardService)
            },
            injury: {
                standard: inject(IncidentReportInjuryStandardService)
            },
            note: {
                standard: inject(IncidentReportNoteStandardService),
                mediaFile: {
                    standard: inject(IncidentReportNoteMediaFileStandardService)
                }
            },
            mediaFile: {
                standard: inject(IncidentReportMediaFileStandardService)
            },
            reporterApproval: {
                standard: inject(IncidentReportReporterApprovalStandardService),
                composite: inject(IncidentReportReporterApprovalCompositeService)
            },
            summaryDocument: {
                standard: inject(IncidentReportSummaryDocumentStandardService)
            }
        };
        this.inventoryType = {
            base: inject(InventoryTypeBaseService)
        };
        this.manifest = {
            standard: inject(ManifestStandardService),
            attestation: {
                standard: inject(ManifestAttestationStandardService)
            },
            employeeApproval: {
                standard: inject(ManifestEmployeeApprovalStandardService)
            },
            product: {
                standard: inject(ManifestProductStandardService),
                safetyBriefingStep: {
                    standard: inject(ManifestProductSafetyBriefingStepStandardService)
                },
                equipmentCheck: {
                    standard: inject(ManifestProductEquipmentCheckStandardService)
                },
                equipmentItem: {
                    standard: inject(ManifestProductEquipmentItemStandardService)
                },
                preRentalPhoto: {
                    standard: inject(ManifestProductPreRentalPhotoStandardService)
                }
            },
            productType: {
                safetyBriefingStep: {
                    standard: inject(ManifestProductTypeSafetyBriefingStepStandardService)
                },
                equipmentCheck: {
                    standard: inject(ManifestProductTypeEquipmentCheckStandardService)
                },
                equipmentItem: {
                    standard: inject(ManifestProductTypeEquipmentItemStandardService)
                },
                preRentalPhoto: {
                    standard: inject(ManifestProductTypePreRentalPhotoStandardService)
                }
            },
            readyToLaunch: {
                standard: inject(ManifestReadyToLaunchStandardService)
            }
        };
        this.product = {
            base: inject(ProductBaseService)
        };
        this.productType = {
            standard: inject(ProductTypeStandardService),
            preRentalPhoto: {
                standard: inject(ProductTypePreRentalPhotoStandardService)
            },
            preRentalPhotoConfiguration: {
                standard: inject(ProductTypePreRentalPhotoConfigurationStandardService)
            },
            equipmentCheckConfiguration: {
                standard: inject(ProductTypeEquipmentCheckConfigurationStandardService)
            },
            equipmentItemConfiguration: {
                standard: inject(ProductTypeEquipmentItemConfigurationStandardService)
            },
            safetyBriefingStepConfiguration: {
                standard: inject(ProductTypeSafetyBriefingStepConfigurationStandardService)
            }
        };
        this.reservation = {
            composite: inject(ReservationCompositeService),
            signedDocument: {
                standard: inject(ReservationSignedDocumentStandardService)
            },
            status: {
                standard: inject(ReservationStatusStandardService)
            }
        };
        this.http = inject(HttpClient);
        this.configService = inject(RentalsApiClientConfigService);
        this.configService.setConfig(config);
    }
    setConfig(config) {
        this.configService.setConfig(config);
    }
    healthCheck() {
        const url = `${this.config.apiUrl}/health-check`;
        return this.http.get(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientService, deps: [{ token: RENTALS_API_CLIENT_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [RENTALS_API_CLIENT_CONFIG]
                }] }]; } });

const RentalsServices = [
    CompanyFeaturesBaseService,
    IncidentReportStandardService,
    IncidentReportCompositeService,
    IncidentReportReporterApprovalCompositeService,
    IncidentReportReporterApprovalStandardService,
    IncidentReportDamageStandardService,
    IncidentReportInjuryStandardService,
    IncidentReportNoteStandardService,
    IncidentReportNoteMediaFileStandardService,
    IncidentReportMediaFileStandardService,
    IncidentReportSummaryDocumentStandardService,
    ReservationSignedDocumentStandardService,
    ReservationCompositeService,
    ReservationStatusStandardService,
    InventoryTypeBaseService,
    ManifestAttestationStandardService,
    ManifestEmployeeApprovalStandardService,
    ManifestProductEquipmentCheckStandardService,
    ManifestProductEquipmentItemStandardService,
    ManifestProductSafetyBriefingStepStandardService,
    ManifestProductStandardService,
    ManifestProductTypeEquipmentCheckStandardService,
    ManifestProductTypeEquipmentItemStandardService,
    ManifestProductTypeSafetyBriefingStepStandardService,
    ManifestStandardService,
    ProductBaseService,
    ProductTypeStandardService,
    ManifestReadyToLaunchStandardService,
    ProductTypePreRentalPhotoConfigurationStandardService,
    ManifestProductPreRentalPhotoStandardService,
    ManifestProductTypePreRentalPhotoStandardService,
    ProductTypePreRentalPhotoStandardService,
    ProductTypeEquipmentCheckConfigurationStandardService,
    ProductTypeEquipmentItemConfigurationStandardService,
    ProductTypeSafetyBriefingStepConfigurationStandardService
];

class RentalsApiClientModule {
    static forRoot(config) {
        return {
            ngModule: RentalsApiClientModule,
            providers: [
                { provide: RENTALS_API_CLIENT_CONFIG, useValue: config },
                RentalsApiClientService,
                RentalsServices
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientModule, imports: [CommonModule, HttpClientModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientModule, imports: [CommonModule, HttpClientModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RentalsApiClientModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule, HttpClientModule],
                    exports: []
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RENTALS_API_CLIENT_CONFIG, RentalsApiClientConfigService, RentalsApiClientModule, RentalsApiClientService };
